import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/pt';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from './translations/de';
import en from './translations/en';
import it from './translations/it';
import pt from './translations/pt';
import fr from './translations/fr';
import es from './translations/es';

export const resources = {
  en,
  de,
  it,
  pt,
  fr,
  es,
} as const;

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    debug: true,
    fallbackLng: 'en',
    lng: 'en', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    ns: [
      'accommodationList',
      'common',
      'chat',
      'signIn',
      'signUp',
      'transportList'
    ],
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
